// components
import Avatar from './Avatar'

// styles
import './Components.css'

// global
import { awsDataStore, dbDataStore } from '../store/Store'

export default function OnlineUsers() {
    const users = dbDataStore(dbData => dbData.users)
    const userProfiles = awsDataStore(data => data.userProfiles)

    return (
        <div className='user-list'>
            <h2>Team</h2>
            {users && users.map( user => (
                <div key={user.id} className='user-list-item'>
                    <span>{user.first_name}</span>
                    <div>
                        <span className={user.is_online ? 'online-user' : 'offline-user'}></span>
                        <Avatar pic={userProfiles[user.id]} user={user}/>
                    </div>
                </div>
            ))}
        </div>
    )
}
